import React, { useCallback, useState } from "react";
import { AppDispatch } from "../../..";
import UseUserData from "../../../hooks/UseUserData";
import { CouponUserState } from "../../../interface/interface";
import { InsertCouponChange, InvitationList } from "../../../reducers/data";
import Infinite from "../../Infinite/Infinite";
import Check from "./Check";
type Props = {
  __cancel: () => void;
  dispatch: AppDispatch;
  content: string;
};

function CouponPopup({ __cancel, dispatch, content }: Props) {
  const [
    data,
    SearchUser,
    LeaderInsert,
    LeaderDelete,
    RemoveUsers,
    PagingUpdate,
  ] = UseUserData({ limit: 10000 });
  const [allCheck, setAllcheck] = useState<boolean>(false);
  const [checkData, setCheckData] = useState<CouponUserState[]>([]);

  const handsearch = useCallback((e: string) => {
    SearchUser({ text: e });
  }, []);

  const AllChange = useCallback(() => {
    if (allCheck) {
      setCheckData([]);
    } else {
      setCheckData(data ? data : []);
    }
    setAllcheck(!allCheck);
  }, [allCheck, data]);

  const CheckUser = useCallback(
    (usr_id: string, login_nm: string, usr_email: string, login_id: string) => {
      const clone = checkData.slice();
      const index = clone.findIndex((item) => item.usr_id === usr_id);
      if (index > -1) {
        clone.splice(index, 1);
      } else {
        clone.push({ usr_id, login_nm, usr_email, login_id });
      }
      setCheckData(clone);
    },
    [checkData]
  );
  const __selectUser = useCallback(() => {
    if (content == "invitation") {
      dispatch(InvitationList(checkData));
    } else {
      dispatch(InsertCouponChange(checkData));
    }
    __cancel();
  }, [__cancel, dispatch, checkData, content]);

  return (
    <div className="coupon-popup">
      <div className="wrapper">
        <div className="title">발급 대상 찾기</div>
        <form
          className="input-box"
          onSubmit={(e) => {
            // __searchInit();
            e.preventDefault();
          }}
        >
          <div className="left">
            <input
              type="text"
              placeholder="아이디 검색"
              className="input"
              onChange={(e) => {
                handsearch(e.target.value);
              }}
            ></input>
            <img
              className="search"
              src="/assets/common/search.svg"
              // onClick={__searchInit}
            />
          </div>
          <div
            className={`right ${allCheck ? "right-check" : ""}`}
            onClick={AllChange}
          >
            <div className="check">
              {allCheck ? (
                <img src="/assets/common/check.svg" alt="" />
              ) : undefined}
            </div>
            <div className="title">전체선택</div>
          </div>
        </form>
        {data ? (
          <React.Fragment>
            <div className="name-box">
              <div className="title1">이름</div>
              <div className="title2">아이디</div>
              <div className="title3">이메일</div>
            </div>
            <div className="list">
              {data.map((item, index) => {
                return (
                  <Check
                    key={index}
                    data={item}
                    all={allCheck}
                    CheckUser={CheckUser}
                    checkdata={checkData}
                  />
                );
              })}
              <Infinite PagingUpdate={PagingUpdate} />
            </div>
          </React.Fragment>
        ) : (
          <div className="not-list">
            <div className="img">
              <img src="/assets/common/popup-delete.svg"></img>
            </div>
            <div className="title">해당 회원은 존재하지 않습니다.</div>
          </div>
        )}
        <div
          className={`select-btn ${
            checkData.length > 0 || allCheck ? "active-btn" : ""
          }`}
          onClick={__selectUser}
        >
          <div className="title">선택 완료</div>
        </div>
      </div>
    </div>
  );
}

export default CouponPopup;

const box = [
  {
    name: "홍길동",
    id: "kss0354",
    email: "bubi1995@naver.com",
  },
  {
    name: "김성섭",
    id: "k4235s0354",
    email: "bubi1995@naver.com",
  },
  {
    name: "곽병준",
    id: "sdvbx23r",
    email: "bubi1995@naver.com",
  },
  {
    name: "천홍완",
    id: "kss0ssdvxc354",
    email: "bubi1995@naver.com",
  },
  {
    name: "이호영",
    id: "dsfsfb2w3er",
    email: "bubi1995@naver.com",
  },
  {
    name: "김용우",
    id: "sdfxcv234",
    email: "bubi1995@naver.com",
  },
  {
    name: "홍길동",
    id: "sdfsv324234",
    email: "bubi1995@naver.com",
  },
  {
    name: "홍길동",
    id: "sdfh3rt2e",
    email: "bubi1995@naver.com",
  },
];
